import { cn } from '@/lib/utils';

/**
 * EmptyState — estado vacío premium unificado para toda la app.
 *
 * Estructura: icono-en-círculo con acento + título + descripción + CTA opcional.
 * El acento sigue el tema (--primary) por defecto; para estados semánticos
 * (advertencia, error) se puede pasar `tone` para fijar el color.
 *
 * Props:
 * - icon: componente de lucide-react (requerido)
 * - title: encabezado corto (requerido)
 * - description: línea de apoyo (opcional)
 * - action: nodo (Button/Link) que se renderiza como CTA (opcional)
 * - tone: 'primary' (tema, default) | 'warning' | 'danger' | 'muted'
 * - className: clases extra para el contenedor
 */
const TONES = {
  primary: 'bg-primary/10 text-primary',
  warning: 'bg-amber-500/10 text-amber-400',
  danger: 'bg-red-500/10 text-red-400',
  muted: 'bg-zinc-800/60 text-zinc-500',
};

const EmptyState = ({
  icon: Icon,
  title,
  description,
  action,
  tone = 'primary',
  className,
  ...props
}) => {
  return (
    <div
      className={cn('flex flex-col items-center text-center py-10 px-4', className)}
      {...props}
    >
      {Icon && (
        <div
          className={cn(
            'w-16 h-16 rounded-2xl flex items-center justify-center mb-4',
            TONES[tone] || TONES.primary,
          )}
        >
          <Icon className="w-8 h-8" />
        </div>
      )}
      <h3 className="font-display font-bold text-lg text-white uppercase tracking-wide">
        {title}
      </h3>
      {description && (
        <p className="text-zinc-500 text-sm font-body mt-1 max-w-xs">
          {description}
        </p>
      )}
      {action && <div className="mt-5 w-full flex justify-center [&>*]:max-w-full">{action}</div>}
    </div>
  );
};

export { EmptyState };
export default EmptyState;
